import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navigation = () => {
  const location = useLocation();

  return (

    <div className="menubar-area style-3 footer-fixed">
      <div className="toolbar-inner menubar-nav">
        <Link to="/" className={`nav-link ${location.pathname === '/home' ? 'active' : ''}`}>
        <i className="fa-solid fa-house"></i>
        </Link>

        <Link to="/notifications" className={`nav-link ${location.pathname === '/notifications' ? 'active' : ''}`}>
        <i className="flaticon flaticon-sparkle"></i>
        </Link>
        <Link to="/messages" className={`nav-link ${location.pathname === '/messages' ? 'active' : ''}`}>
        <i className="flaticon flaticon-chat-2"></i>
        </Link>
        <Link to="/profile" className={`nav-link ${location.pathname === '/profile' ? 'active' : ''}`}>
        <i className="fa-solid fa-user"></i>
        </Link>
      </div>
    </div>
  );
};

export default Navigation;
